import ActionTypes from '../constants/ActionTypes';

const EMPTY_QUESTIONS = [];

export function areQuestionsLoaded(state, key) {
  return !!(
    state.questions.status[key] &&
    state.questions.status[key] === ActionTypes.FETCH_QUESTIONS_SUCCESS
  );
}

export function getQuestionsByCategoryKey(state, key) {
  return state.questions.list[key] || EMPTY_QUESTIONS;
}
